import { useState, useEffect, useCallback } from 'react'
import api from '../utils/api'
import type { Channel } from '../types/domain'

export function useChannels() {
  const [channels, setChannels] = useState<Channel[]>([])
  const [loading, setLoading] = useState(true)
  const [error, setError] = useState<string | null>(null)

  const fetch = useCallback(async () => {
    try {
      setLoading(true)
      const { data } = await api.get<Channel[]>('/comms/channels')
      setChannels(data)
    } catch (err) {
      setError((err as Error).message)
    } finally {
      setLoading(false)
    }
  }, [])

  useEffect(() => { fetch() }, [fetch])

  return { channels, loading, error, refetch: fetch }
}
